// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__dAh-d","active":"NavItem_active__t1mta"};